export default __webpack_public_path__ + "static/media/SHOT2.fbc15f81.png";